// extracted by mini-css-extract-plugin
export default {"contentWrapper":"Modal_contentWrapper__FkVRZ","actionWrapper":"Modal_actionWrapper__ldiWU","headerWrapper":"Modal_headerWrapper__jf7bd"};